import React  from 'react';

import SiosTableApp from "../Functionality/SiosTableApp";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import CustomTable from "../../../../../components/table/CustomTable";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import CreateSIOSModal from "../../SIOs/Modal/CreateSIOSModal";
import DeleteModal from "../../../../Modals/DeleteModal";
import DividerWithText from "../../../../../components/DividerWithText";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SiosTable = ({ defaultSioList, disabled }) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        setSelectedList,
        showCreateSioModal,
        setShowCreateSioModal,
        showDeleteSioModal,
        setShowDeleteSioModal,
        isAllChecked,
        setIsAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedSio
    } = SiosTableApp({
        defaultSioList
    });

    return (
        <>
            <div className='row mt-4'>
                <DividerWithText title={t('SIOs')} />
                {!disabled && (
                <div className='d-flex justify-content-end mb-2'>
                    <ButtonAction
                        id='btn_st_delete_sios'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setShowDeleteSioModal(true);
                        }}
                    />
                </div>
                )}
                <CustomTable
                    tableId={tableId}
                    checkbox={!disabled}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
                {!disabled && (
                <div className='my-2'>
                    <ButtonLargeTransparent
                        id="btn_st_create_sio"
                        click={() => {
                            setShowCreateSioModal(true);
                        }}
                        text={t("create_sio")}
                    />
                </div>
                )}
            </div>

            {showCreateSioModal &&
                <CreateSIOSModal
                    controllerId={id}
                    show={showCreateSioModal}
                    onHide={()=> setShowCreateSioModal(false)}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={showDeleteSioModal}
                onHide={() => setShowDeleteSioModal(false)}
                onClickFn={() => deleteSelectedSio()}
                data={selectedList}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_sio')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('sios')}
            />
        </>
    );
};

export default SiosTable;
